// client/src/constants/index.js
import parse from 'html-react-parser';

// per https://medium.com/@austinpaley32/how-to-add-a-constants-file-to-your-react-project-6ce31c015774
// import * as Constants from './constants'
// invoke via: Constants.[CONSTANTNAME]

// examples from article:
// export const DJISYMBOL = "&symbol=DJI"
// export const DeleteButton = require('../images/delete-icon.png')

export const O_COL_SYM = parse("&#12295;");
// &#9675; - a small circle
// &#12295; - a big circle, not far off of an "O"
// &#9711; - the biggest circle
// &#8413;  - a _____ circle
// &#11096; - a _____ circle
// &#11422; - coptic capital letter O
// &#927; - greek capital letter omicron

// export const GREEK_OM_SYM = parse("&#927;");
// export const COPTIC_O_SYM = parse("&#11422;");

export const X_COL_SYM = parse("&#9587;");
// an 'X' symbol, noticeably larger than "X"

export const VIDEO_SYM = parse("&#127910;");
// 'cinema' symbol for inclusion in Tippy messages about video tool tips

export const QMARK_SYM = parse("&#x2370;");
// unicode for question mark inside of square. I wish 'inside of circle' but ok.

export const TM_SYM = parse("&#x2122;");
// unicode for trademark symbol (TM)

export const ONE_THIRD = parse("&frac13;");
// unicode for 1/3

export const TWO_THIRDS = parse("&frac23;");
// unicode for 2/3

export const THREE_EIGHTHS = parse("&frac38;");
// unicode for 3/8

export const FIVE_EIGHTHS = parse("&frac58;");
// unicode for 5/8

// article notes could create mini files in src/constants, e.g.:
//matcher.js
// then export them from here (index.js) via:
// export * from './matcher';

//some salmon options: FF6F59 or E85D63 & FF7B7B FF5252
//some lightblue options: 9AD7FE  D0F3FC - don't know value for 'lightblue'
//a green complement: 65B362
export const O_BOX_GREEN = "#65B362";
export const O_BOX_RED   = "#FF6F59";
export const O_BOX_PINK  = "#FEC1CB";
export const O_BOX_YELLOW= "#FFFF99";

export const LIGHT_RED = "#FFBABA";
export const LIGHT_GREEN = "#E6FCE5";
export const LIGHT_BLUE = "#9AD7FE";
export const VERY_LIGHT_BLUE = "#EBF9FF";

export const SHOW_SHAREABLE = true;

export const TIPPY_SEPARATOR = ' //';
export const TIPPY_HELP_VOICE = 'google_en_us_female';
export const TIPPY_TTS_RATE = 1;
export const HELP_VOICE_DATA = 'Google|en-US|female';
export const LAST_SKU_CATEGORY_INDEX = 36;

export const SHOW_AUDIO_UPON_MIN_CHARS = 50;

// Invitation 'status' exactly as the API sends and expects it: Rails
// validates these four strings ('enum :status' in
// 'app/models/invitation.rb'), so they are wire values, not labels.
// They must never live in a translation file - a sync would render them
// as 'Aceptada' and every POST would fail validation, which is what
// used to happen on the es and ht pages. What the shopper reads is
// 'invitation.status.label0'..'label3'; see 'lookup_status_label'.
// Index matches the dropdown option values in 'InvitationEditForm'.
export const INVITATION_STATUSES = [
  'NotResponded',  // 0
  'Accepted',      // 1
  'Rejected',      // 2
  'Improper',      // 3
];
export const INVITATION_STATUS_ACCEPTED = INVITATION_STATUSES[1];

// Sample values quoted inside FAQ help text. They are data, not
// language - a store code reads the same in every locale - so they are
// interpolated rather than embedded in the translated strings. That
// keeps one copy here instead of one per locale file, and it keeps the
// '_SPOKEN' spacing away from translators entirely.
//
// Named for the FAQ topic each one illustrates, not for the kind of
// value it is: another topic may well want its own barcode or its own
// split, and 'FAQ_SHARING_BARCODE' leaves room for that in a way a
// bare 'BARCODE' would not.
//
// A '_SPOKEN' twin spaces the digits out so a voice reads an identifier
// digit by digit rather than as a magnitude ('3 million ...'), in
// whatever language that voice speaks. Its leading ',' stops the run
// being swallowed by the words ahead of it; there is no trailing one,
// because the sentence supplies its own punctuation.
export const FAQ_SHARING_BARCODE = '069055135471';
  // No spoken twin needed: a leading zero already forces any engine to
  // read this one digit by digit.
export const FAQ_SHARING_STORE_CODE        = '3392701';
export const FAQ_SHARING_STORE_CODE_SPOKEN = ', 3, 3, 9, 2, 7, 0, 1';
export const FAQ_COMBINED_INTEREST_SPLIT        = '25-25-50';
export const FAQ_COMBINED_INTEREST_SPLIT_SPOKEN = ', 25, 25, 50';

export const OI_DELETE_BATCH_SIZE = 100;
//export const OI_DELETE_BATCH_SIZE = 1;
export const SMALL_NUM_OF_OIS = 5;

export const SMALL_NUM_OF_SKUS = 1;
export const SMALL_NUM_OF_TRIPS = 1;

export const SMALL_NUM_OF_MENU_ITEMS = 6;

export const TRIP_LABEL_MAX_LENGTH = 42;
export const MAX_SKU_IDENTIFIER_CHARS_BEFORE_TIPPY = 8;
export const MAX_SKU_STORE_CHARS_BEFORE_TIPPY = 8;
export const MAX_SKU_SEARCH_RESULTS = 15;

export const DONTSHOW = "DONTSHOW";
export const DOT = ".";
export const DASH = "-";

export const VERTICAL_OI_COLUMNS = 10;

export const FEEDBACK_ROWS = 5;
export const FEEDBACK_COLUMNS = 32;
export const FEEDBACK_MAX_CHARS = 1000;
export const AUDIO_FEEDBACK_TAG = 'clickAudioMessage';
export const VIDEO_FEEDBACK_TAG = 'clickVideoMessage';

export const IDENTIFIER_MAX_LENGTH = 30;
export const NAME_MAX_LENGTH = 40;
export const EMAIL_MAX_LENGTH = 65;
export const RANGE_NOTE_MAX_CHARS = 128;

// limits for Circle Plan resources
export const MAX_PLAN_SKUS = 400;

export const MAX_PLAN_TRIPS_3 = 100;
export const MAX_PLAN_OITEMS_3 = 2000;
export const MAX_PLAN_SKU_SEARCHES_3 = 200;
export const MAX_PLAN_SKU_SEARCHES_WEEKLY_3 = 40;

export const MAX_PLAN_TRIPS_5 = 120;
export const MAX_PLAN_OITEMS_5 = 3000;
export const MAX_PLAN_SKU_SEARCHES_5 = 300;
export const MAX_PLAN_SKU_SEARCHES_WEEKLY_5 = 60;

export const MAX_PLAN_TRIPS_8 = 140;
export const MAX_PLAN_OITEMS_8 = 5000;
export const MAX_PLAN_SKU_SEARCHES_8 = 400;
export const MAX_PLAN_SKU_SEARCHES_WEEKLY_8 = 80;

// localStorage basenames:
export const LAST_TRIP_SEEN_FOR = "LAST_TRIP_SEEN_FOR_";

export const INVITE_TIME_QUERY_LABEL = "invtime";

// terms for icons that GetIcon handles
export const GET_ICON_RT_ARROW    = "arrowRight";
export const GET_ICON_RT_ARROW_2EM_GRAY = "arrowRight2emGray";
export const GET_ICON_CIRCLE_INFO = "circleInfo";
export const GET_ICON_CIRCLE_HOOK = "circleHook";
export const GET_ICON_DETAILS     = "details";
export const GET_ICON_DETAILS_HEADING = "detailsHeading";
export const GET_ICON_TRIANGLE_BANG = "triangleBang";
export const GET_ICON_ASTERISK    = "asterisk";
export const GET_ICON_PLUS        = "plus";
export const GET_ICON_Q4MOON      = "q4moon";
export const GET_ICON_CHAT        = "chat";
export const GET_ICON_CHANGE      = "change";
export const GET_ICON_HIDE        = "hide";
export const GET_ICON_REFRESH     = "refresh";
export const GET_ICON_WRENCH      = "wrench";
export const GET_ICON_SEARCH      = "magnify";
export const GET_ICON_COPY        = "copy";
export const GET_ICON_PASTE       = "paste";
export const GET_ICON_BARCODE     = "barcode";
export const GET_ICON_GLOBE       = "globe";
export const GET_ICON_AUDIO       = "audioPlayback";
export const GET_ICON_VIDEO       = "videoPlayback";

export const HAS_UUID_PROFILE
                    = new RegExp(/^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/);

const validCircleCountriesString = "US CA MX DZ AD AR AU AT BH BD BE BR BG CL CN CO CZ DK EC EG EE FI FR DE GH GR HU IS IN ID IE IL IT JP JO KE KW LV LT LU MY MT MC MA NP NL NZ NG NO OM PK PG PE PH PL PT RO SM SA SG SK ZA KR ES LK SE CH TW TZ TH TN TR UA GB UY VE VN"
export const VALID_CIRCLE_COUNTRIES = validCircleCountriesString.split(" ");

// Mirrors Circle::TOPOFF_LEVELS, which the backend derives from the
// min/max/step in config/constants/circle.yml. The backend rejects any
// value off this ladder, so the two must be changed together.
// High-to-low, and the 'circle.topoff.optionValue<n>' translation keys
// are positional against it: optionValue0 labels the first entry. So
// extending the ladder downward just appends keys, but raising its top
// would shift every key's meaning.
const topoffLevelsString = "100 95 90 85 80 75 70 65 60 55 50";
export const TOPOFF_LEVELS = topoffLevelsString.split(" ").map(Number);

const validTimeZonesString = `
guam midway_island american_samoa hawaii alaska
pacific_time_us_n_canada arizona mountain_time_us_n_canada
central_time_us_n_canada indiana_east
eastern_time_us_n_canada puerto_rico fiji wellington
new_caledonia sydney melbourne darwin tokyo seoul
perth singapore bangkok rangoon dhaka kathmandu
kolcata mumbai islamabad karachi kabul baku tehran
nairobi cairo jerusalem kyiv riga berlin madrid
west_central_africa london monrovia azores
brasilia buenos_aires montevideo newfoundland
georgetown santiago caracas lima bogota
mexico_city saskatchewan mazatlan tijuana
`;

export const VALID_TIME_ZONES =
  validTimeZonesString.split(/\s+/).filter(word =>  word !== "");

// Voice catalog, sorted by locale. Entries are
//   [ slug, voiceName, locale, sex, displayOverride ]
//
// 'slug' is what lands in 'shoppers.help_voice'. It stays a stable,
// device-independent token on purpose: the same saved preference has to
// mean the same thing on a phone and on a laptop, even though the two
// have entirely different voices installed.
//
// 'voiceName' is matched against 'SpeechSynthesisVoice.name' from
// 'getVoices()'. When a device lacks that voice - every 'Google' entry
// is absent on iOS, for instance - 'TextToSpeech' hands 'locale' to
// 'utterance.lang' and the device speaks the right language in whatever
// voice it does have. That fallback is why we can list a language
// without hand-verifying a named voice for it on every platform.
//
// 'sex' describes the voice we ask for, not necessarily the one that
// speaks: a fallback lands on the OS default for the locale, whose sex
// varies by language (iOS answers nl-NL with a male voice, de-DE with a
// female one). So it is deliberately not shown to shoppers, except via
// 'displayOverride' where two entries would otherwise look identical.
//
// Shopper-facing labels are built at render time from 'Intl.
// DisplayNames' rather than from translation keys - see
// 'voice_option_groups' in 'useSkuUtils'.
export const VOICE_CATALOG = [
  [ "google_de_de_female", "Google",    "de-DE", "female" ],
  [ "martin",              "Martin",    "de-DE", "male"   ],
  [ "melina",              "Melina",    "el-GR", "female" ],
  [ "catherine",           "Catherine", "en-AU", "female" ],
  [ "gordon",              "Gordon",    "en-AU", "male"   ],
  [ "karen",               "Karen",     "en-AU", "female" ],
  [ "arthur",              "Arthur",    "en-GB", "male"   ],
  [ "google_en_gb_female", "Google UK English Female",
                                        "en-GB", "female", "Google ♀" ],
  [ "google_en_gb_male",   "Google UK English Male",
                                        "en-GB", "male",   "Google ♂" ],
  [ "martha",              "Martha",    "en-GB", "female" ],
  [ "moira",               "Moira",     "en-IE", "female" ],
  [ "rishi",               "Rishi",     "en-IN", "male"   ],
  [ "aaron",               "Aaron",     "en-US", "male"   ],
  [ "google_en_us_female", "Google",    "en-US", "female" ],
  [ "nicky",               "Nicky",     "en-US", "female" ],
  [ "samantha",            "Samantha",  "en-US", "female" ],
  [ "tessa",               "Tessa",     "en-ZA", "female" ],
  [ "google_es_es_male",   "Google",    "es-ES", "male"   ],
  [ "google_es_us_female", "Google",    "es-US", "female" ],
  [ "google_fr_fr_female", "Google",    "fr-FR", "female" ],
  [ "marie",               "Marie",     "fr-FR", "female" ],
  [ "google_hi_in_female", "Google",    "hi-IN", "female" ],
  [ "google_it_it_female", "Google",    "it-IT", "female" ],
  [ "google_nl_nl_female", "Google",    "nl-NL", "female" ],
  [ "google_pl_pl_female", "Google",    "pl-PL", "female" ],
  [ "vani",                "Vani",      "ta-IN", "female" ],
  [ "google_zh_cn_female", "Google",    "zh-CN", "female" ],
  [ "tingting",            "Tingting",  "zh-CN", "female" ],
  [ "google_zh_hk_female", "Google",    "zh-HK", "female" ],
  [ "google_zh_tw_female", "Google",    "zh-TW", "female" ],
]

export const VALID_VOICES = VOICE_CATALOG.map(([slug]) => slug)